import { Action, Reducer, ActionCreator, combineReducers } from 'redux';
import { ThunkAction } from 'redux-thunk';

import { RootState } from '..';
import { IEciImplantOutForecastState } from '../../interfaces/states/IEciImplantOutForecastState';
import { IErrors } from '../../common/model/errors.model';

export enum Type {
  SET_SPINNERUPLOADOUTFORECASTAPPFORM = '@@eciImplantOutForecast/SET_SPINNERUPLOADOUTFORECASTAPPFORM',
  SET_ERRORS = '@@eciImplantOutForecast/SET_ERRORS',
}

const initialState: IEciImplantOutForecastState = {
  errors: {},
  uploadOutForecastFileSpinner: false
};

// Actions

export type Actions = SetSpinnerUploadOutForecastAppFormAction | SetErrorsAction;

export interface SetSpinnerUploadOutForecastAppFormAction extends Action<Type.SET_SPINNERUPLOADOUTFORECASTAPPFORM> {
  showSpinner: boolean;
}

export interface SetErrorsAction extends Action<Type.SET_ERRORS> {
  errors: IErrors;
}

export const setSpinnerUploadOutForecastAppForm: ActionCreator<SetSpinnerUploadOutForecastAppFormAction> = (showSpinner: boolean) => ({
  type: Type.SET_SPINNERUPLOADOUTFORECASTAPPFORM,
  showSpinner: showSpinner
});

export const setErrors: ActionCreator<SetErrorsAction> = (errors: IErrors) => ({
  type: Type.SET_ERRORS,
  errors: errors
});

export const setErrorsInState: ActionCreator<ThunkAction<void, RootState, unknown, Actions>> = (
  errors: IErrors
) => (
  async (dispatch) => {
    dispatch(setErrors(errors));
  }
);

export const spinnerUploadOutForecastAppForm: ActionCreator<ThunkAction<void, RootState, unknown, Actions>> = (
  showSpinner: boolean
) => (
  async (dispatch) => {
    dispatch(setSpinnerUploadOutForecastAppForm(showSpinner));
  }
);

// Reducers

const errors: Reducer<IErrors> = (state = initialState.errors, action) => {
  switch (action.type) {
    case Type.SET_ERRORS:
      return (action as SetErrorsAction).errors;
    default:
      return state;
  }
};

const uploadOutForecastFileSpinner: Reducer<boolean> = (state = initialState.uploadOutForecastFileSpinner, action) => {
  switch (action.type) {
    case Type.SET_SPINNERUPLOADOUTFORECASTAPPFORM:
      return (action as SetSpinnerUploadOutForecastAppFormAction).showSpinner;
    default:
      return state;
  }
};

export const eciImplantOutForecastStore = combineReducers({
  errors,
  uploadOutForecastFileSpinner
});
